import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_rise",
  "use": "icon-project_rise-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_rise\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M5.5 11.006l6-3.919 6 2.904L23.5 5\" /><path d=\"M23.5 10.5v13M17.5 14.5v9M11.5 12.5v11M5.5 16.5v7M23.5 5l-3.14-.667M23.5 5v3.003\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol